import useSWR from "swr";
import { AgentService } from "@/services/agent/agent.service";
import { defaultSWROption } from "@/services/api/api.service";

export const useCommands = (workspaceId: string | null, enabledOnly: boolean = true) => {
  const fetcher = async () => {
    if (!workspaceId) return [];
    const commands = await AgentService.getCommands(workspaceId);
    // enabledOnly=true の場合は enabled=true のコマンドだけをフィルタリング
    return enabledOnly ? commands.filter((cmd) => cmd.enabled) : commands;
  };

  const { data, error, isLoading, mutate } = useSWR(
    workspaceId ? ["agent", "commands", workspaceId, enabledOnly] : null,
    fetcher,
    defaultSWROption,
  );

  return {
    commands: data ?? [],
    error,
    isLoading,
    mutate,
  };
};
